var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm.paymentStatus.text
    ? _c("span", { class: `text-${_vm.paymentStatus.color}` }, [
        _vm._v(_vm._s(_vm.paymentStatus.text)),
      ])
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }